import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, Button, Upload, Popconfirm } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { saveAs } from 'file-saver';
import { IPageProps } from '../../../interfaces/page-data';
import HTTPService from '../../../utils/makerequest';
import { t } from 'i18next';

const TransferLicence: React.FunctionComponent<IPageProps> = (props) => {
  const { licenceKey, param } = useParams<{ licenceKey: string; param: string }>();
  const [token, setToken] = useState('');
  const formRef = useRef(null);
  const [isFinishTransferVisible, setIsFinishTransferVisible] = useState(false);
  const [isError, setIsError] = useState(true);
  const [transferToken, setTransferToken] = useState('');
  const toast = useRef<any>(null);

  useEffect(() => {
    GetTransfer();
  }, [licenceKey, param]);

  const GetTransfer = () => {
    HTTPService.GET(`/Licence/transferToken?licenceKey=${licenceKey}`)
      .then((response) => {
        if (response.status === 200) {
          const tmp = response.data;
          const transferToken = tmp.token;
          setTransferToken(transferToken);
        } else if (response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error('Token Error:', error);
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('error_message'),
          life: 3000
        });
      });
  };

  const TransferLicense = (values) => {
    var token = values.transferLicense;
    HTTPService.GET(
      `/Licence/transferLicence?licenceKey=${licenceKey}&token=${encodeURIComponent(token)}`

    )
      .then((response) => {
        if (response.status === 200) {
          const tmp = response.data;
          const token = tmp.token;
          setToken(token);
          setIsError(false);
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('transferLicenceCompleted'),
            life: 3000
          });
        } else if (response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error('Transfer Licence Error:', error);
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('transfer_licence_error'),
          life: 3000
        });
      });
  };

  const handleFormSubmit = (values: any) => {
    formRef.current.submit();
  };

  const handleTransfer = (info) => {
    if (info.file.status !== 'uploading') {
      const formData = new FormData();
      formData.append('licenceKey', licenceKey);
      formData.append('token', info.file.originFileObj);

      HTTPService.POST(`/Licence/step2/File?licenceKey=${licenceKey}`, formData)
        .then((response) => {
          if (response.status === 200) {
            const tmp = response.data;
            const token = tmp.token;
            toast.current?.show({
              severity: 'success',
              summary: t('successful'),
              detail: t('fileUpload'),
              life: 3000
            });
            setToken(token);
            setIsError(false);
          }
        })
        .catch((error) => {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t('file_error'),
            life: 3000
          });
        });
    }
  };

  const handleCopyToClipboard = () => {
    const textField = document.createElement('textarea');
    textField.innerText = token;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    toast.current?.show({
      severity: 'success',
      summary: t('successful'),
      detail: t('tokenCopy'),
      life: 3000
    });

  };
  const handleCopyTransfer = () => {
    const textField = document.createElement('textarea');
    textField.innerText = transferToken;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    toast.current?.show({
      severity: 'success',
      summary: t('successful'),
      detail: t('tokenCopy'),
      life: 3000
    });
  };

  const Download = async () => {
    try {
      let fileName = 'KeyFile';
      const blob = new Blob([transferToken], { type: 'application/octet-stream' });
      saveAs(blob, fileName);
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: t('errors'),
        detail: t('errorDownload'),
        life: 3000
      });
    }
  };
  const DownloadFinish = async () => {
    try {
      let fileName = 'KeyFile';
      const blob = new Blob([token], { type: 'application/octet-stream' });
      saveAs(blob, fileName);
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: t('errors'),
        detail: t('errorDownload'),
        life: 3000
      });
    }
  };
  const Complete = () => {
    if (param == "1") {
      window.location.replace('/admin/customer-management/');
    }
    else {
      window.location.replace('/admin/company-management/');
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div
        style={{ padding: '20px', maxWidth: '800px', margin: 'auto', border: '1px solid black' }}>
        <h3 style={{ color: 'red' }}>{t('transferKey')}</h3>
        <div style={{ overflow: 'hidden' }}>
          <p style={{ width: '750px', height: '250px' }}>{transferToken}</p>
        </div>
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
            <Button
              type='primary'
              onClick={() => {
                handleCopyTransfer();
                setIsFinishTransferVisible(true);
              }}>
              {t('copy')}{' '}
            </Button>
            <Button
              type='primary'
              onClick={() => {
                Download();
                setIsFinishTransferVisible(true);
              }}>
              {t('download')}{' '}
            </Button>
          </div>
        </div>
      </div>
      <div style={{ height: '40px' }}></div>
      {isFinishTransferVisible && (
        <div
          style={{
            padding: '20px',
            maxWidth: '800px',
            height: 'auto',
            margin: 'auto',
            border: '1px solid black',
          }}>
          <h3 style={{ color: 'red' }}>{t('transferLicence')}</h3>
          <div>
            <Form ref={formRef} onFinish={TransferLicense}>
              <Form.Item
                name='transferLicense'
                label={t('transferLicence')}
                style={{ marginBottom: '30px' }}>
                <Input placeholder={t('enterYourLicenceToken')} style={{ borderRadius: 0 }} />
              </Form.Item>

              <Form.Item
                name='uploadTransfer'
                label={'Upload File' + Array(8).fill('\u00A0').join('')}
                valuePropName='fileList'
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e?.fileList;
                }}
                style={{ marginBottom: '30px', width: '300px', height: '50px' }}>
                <Upload name='logo' listType='text' onChange={handleTransfer} customRequest={({ onSuccess }) => {
                  onSuccess("ok");
                  return true;
                }}>
                  <Button icon={<UploadOutlined />}>{t('upload')}</Button>
                </Upload>
              </Form.Item>

              <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
                  <Popconfirm
                    title={t('transferLicenceComplete')}
                    onConfirm={handleFormSubmit}
                    okText={t('yes')}
                    cancelText={t('no')}>
                    <Button type='primary' htmlType='submit'>
                      {t('transferLicence')}
                    </Button>
                  </Popconfirm>
                </div>
              </div>
            </Form>
          </div>
        </div>
      )}
      <div style={{ height: '40px' }}></div>

      {!isError && (
        <div
          style={{ padding: '20px', maxWidth: '800px', margin: 'auto', border: '1px solid black' }}>
          <h3 style={{ color: 'red' }}>Key</h3>
          <div style={{ overflow: 'hidden' }}>
            <p style={{ width: '750px', height: '150px' }}>{token}</p>
          </div>
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
              <Button
                type='primary'
                onClick={() => {
                  handleCopyToClipboard();
                }}>
                {t('Copy')}{' '}
              </Button>
              <Button
                type='primary'
                onClick={() => {
                  DownloadFinish();
                }}>
                {t('Download')}{' '}
              </Button>
              <Popconfirm
                title={
                  <div>
                    {t('transferLicenceProcess')} <br />
                    {t('transferLicenceAccess')}
                  </div>
                }
                onConfirm={Complete}
                okText='Yes'
                cancelText='No'>
                <Button type='primary' htmlType='submit'>
                  {t('finish')}
                </Button>
              </Popconfirm>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransferLicence;
